var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEhand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 86,
    viewBox: "0 0 73 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8223 80.5675C43.8223 80.5675 43.4505 70.7764 43.2026 66.4385C42.9547 62.1006 43.4505 55.1601 43.2026 52.1855C42.9547 49.211 42.459 46.2365 41.5914 44.2535C40.7238 42.2704 39.4844 38.9241 40.2281 30.7441C40.2281 30.7441 40.5374 28.2039 40.6623 27.2124C40.7863 26.2209 40.9915 24.9815 41.9116 21.7591C42.8318 18.5366 43.389 17.4212 43.8233 15.8715C44.2576 14.3217 43.7618 10.1703 45.0012 8.31119C46.2406 6.45211 47.9142 6.32817 49.5869 7.01033C51.2596 7.69249 51.0127 8.74547 51.5085 10.667C52.0042 12.5886 53.43 15.3767 52.0657 16.1203C50.7014 16.864 48.0997 15.811 47.2321 12.774L46.8603 10.9774",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5571 11.4722C45.5571 11.4722 45.9517 12.0482 47.1485 12.3804",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9619 7.19011C49.9619 7.19011 49.5861 2.98214 52.3128 2.79673C55.0394 2.61132 56.0309 3.41642 56.1549 5.27551C56.2788 7.13459 56.5891 9.18007 56.7121 9.92371C56.835 10.6673 57.2078 13.1461 57.2078 14.1991C57.2078 15.2521 57.3942 17.1122 59.6866 17.2351C61.979 17.3581 62.4747 15.4385 62.4133 12.8348C62.4133 12.8348 62.4747 8.55939 63.0954 7.38147C63.7161 6.20356 64.3348 4.22054 66.1314 4.09759C67.9281 3.97464 68.7342 4.03612 69.7257 5.83273C70.7172 7.62935 70.6557 9.07398 70.3454 12.3797C70.3454 12.3797 70.036 14.9417 69.8496 16.8008C69.6632 18.6599 69.7881 19.589 69.6632 21.8208",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0866 29.5674C64.0866 29.5674 62.9087 29.1956 63.2191 27.7708",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5114 27.4603C65.5114 27.4603 63.3628 28.3279 63.1665 26.9031",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.167 27.3127V25.7253",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3177 22.8124C66.3177 22.8124 65.4689 26.5018 61.7319 25.4151C61.7319 25.4151 58.2616 24.0518 56.7744 22.2542C55.2871 20.4566 56.1547 18.9078 57.2701 18.9693C58.3856 19.0308 62.0522 19.3411 64.3396 18.6599C66.627 17.9778 68.7964 17.5445 69.788 22.7499C70.7795 27.9554 71.5846 29.2562 71.647 30.9299C71.7095 32.6036 71.647 33.3472 67.3092 37.1883C62.9713 41.0294 60.1207 43.4467 60.0593 45.9255C59.9978 48.4043 60.9268 56.027 61.0508 61.17C61.1747 66.3129 63.4681 76.1041 64.2117 81.0002",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6172 15.251C52.6172 15.251 52.871 17.6693 55.0394 17.6693C57.2079 17.6693 57.3288 16.299 57.2545 14.9446",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7681 3.85852C55.7681 3.85852 56.7745 1 59.0678 1C61.3612 1 62.786 2.17791 62.786 3.29237C62.786 4.40683 62.662 9.17897 62.662 9.17897",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3355 14.6402C62.3355 14.6402 62.0509 17.4839 64.3393 17.4214C66.6268 17.3599 66.8132 15.7061 67.185 13.847C67.5568 11.9879 67.4943 11.4297 67.4943 11.4297C67.4943 11.4297 68.4858 10.81 68.7337 10.0039",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3984 60.6758H22.1484V68.293H35.3516V73H16.2891V44.5625H35.3125V49.3086H22.1484V56.0859H33.3984V60.6758Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 61.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhand);
export default __webpack_public_path__ + "static/media/Ehand.0ac31241ee60cc76db5f52da01fe5f0c.svg";
export { ForwardRef as ReactComponent };